import React from "react";
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

class Footer extends React.Component {
    render() {
        return (
            <header className="app-header mb20">
                <div className="header-outer">
                    <Grid className="header-inner" container justify="space-between" alignItems="flex-start">
                        <Grid item>
                            <img src="/images/logo.svg" width="310" alt="logo"/>
                        </Grid>
                        <Grid item>
                            <Typography variant="h5" style={{ fontWeight: "bold", lineHeight: "24px" }} align="right">+7 (812) 458 35 35</Typography>
                        </Grid>
                    </Grid>
                </div>
            </header>
        );
    }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Header.js